
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecosystem",
      function () {
        return require("private-next-pages/ecosystem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecosystem"])
      });
    }
  